module.exports = __webpack_public_path__ + "img/page9img6.1f12c3d4.png";